import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Radio, Input, InputNumber, Popconfirm, Table, Typography, message } from 'antd';
import MyForm from './MyForm'

const BooleanRadio = (
    <Radio.Group>
        <Radio value={false}> false </Radio>
        <Radio value={true}> true </Radio>
    </Radio.Group>
)
//表格可修改化
const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {
    const inputNode = inputType === 'boolean' ? BooleanRadio : inputType === 'number' ? <InputNumber /> : <Input />
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
                    }}
                //是否检测空白报错
                // rules={[{ required: true, message: `请输入 ${title}!`, },]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};
//表格组件
const MyTable = ({ columns, bucketArr, updateInfo, deleteInfo }) => {
    const [messageApi, contextHolder] = message.useMessage();
    const [form] = Form.useForm();
    const [data, setData] = useState([]); //实际的数据内容
    const [editingKey, setEditingKey] = useState(''); //修改按钮是否激活

    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = async (obj) => {
        console.log(obj);

        if (obj.name !== undefined) {
            if (obj.name === '') {
                messageApi.warning('请输入name文件名');
                return
            }
            if (data.find(v => v.name === obj.name)) {
                messageApi.warning('该文件已存在');
                return
            }
        }
        else {
            if (obj.id === undefined) {
                messageApi.warning('请输入name文件名');
                return
            }
            if (data.find(v => v.id === obj.id)) {
                messageApi.warning('该id已存在');
                return
            }
        }
        let result = await updateInfo(obj);
        if (!result) messageApi.error('新增项目失败');
        else {
            if (obj.name !== undefined) {
                obj.key = obj.name;
            }
            else {
                obj.key = obj.id
            }
            setData([...data, obj]);
            setIsModalOpen(false);
        }
        // data.unshift(newData);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const isEditing = (record) => record.key === editingKey;
    //点击修改按钮，表格内个会变成input
    const handleEdit = (record) => {
        form.setFieldsValue({
            name: '',
            age: '',
            address: '',
            ...record,
        });
        setEditingKey(record.key);
    };
    //取消修改
    const cancel = (v) => {
        setEditingKey('');
    };
    //保存修改并更新数据库
    const handleSave = async (record) => {
        try {
            const row = await form.validateFields();
            if (record.name !== undefined) row.name = record.name;
            if (record.id !== undefined) row.id = record.id;
            // console.log('处理前的', record.id);
            //更新数据库
            let result = await updateInfo(row);
            if (!result) throw new Error('Uploadapi Failed')

            const newData = [...data];
            const index = newData.findIndex((item) => record.key === item.key);
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {
                    ...item,
                    ...row,
                });
                setData(newData);
                setEditingKey('');
            } else {
                newData.push(row);
                setData(newData);
                setEditingKey('');
            }
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };

    function attributeCount(obj) {
        var count = 0;
        for (var i in obj) {
            // if (obj.hasOwnProperty(i)) {  // 建议加上判断,如果没有扩展对象属性可以不加
            count++;
            // }
        }
        return count;
    }

    const handleDelete = async (key) => {
        const deletedData = data.find((item) => item.key === key);
        const newData = data.filter((item) => item.key !== key);
        // console.log(deletedData);
        // console.log(newData.length);

        let count = attributeCount(deletedData)
        if (count > 1) {
            let res = await deleteInfo(deletedData);
            if (res) setData(newData);
            else console.log('修改失败');
        }
        else {
            console.log('删除空白项');
            setData(newData);
        }

    };

    //列标题中添加设置，每组数据都添加一个设置按钮
    const setting = [
        {
            title: '设置',
            dataIndex: 'operation',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Typography.Link
                            onClick={cancel}
                            style={{
                                marginRight: 8,
                            }}
                        >
                            取消
                        </Typography.Link>
                        <Popconfirm title="确认修改吗?" cancelText="取消" okText="是的" onConfirm={() => handleSave(record)}>
                            <a>确认</a>
                        </Popconfirm>
                    </span>
                ) : (
                    <>
                        <Typography.Link disabled={editingKey !== ''} onClick={() => handleEdit(record)}>
                            修改
                        </Typography.Link>
                        <Popconfirm disabled={editingKey !== ''} title="确认删除吗" cancelText="取消" okText="是的" onConfirm={() => handleDelete(record.key)}>
                            <a>  删除</a>
                        </Popconfirm>
                    </>

                );
            },
        }
    ]
    const allColumns = columns.concat(setting);

    const mergedColumns = allColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: col.type,
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });

    useEffect(() => {
        setData(bucketArr);
        return () => {

        }
    }, []);

    return (
        <>
            {contextHolder}
            <Button
                onClick={showModal}
                type="primary"
                style={{
                    marginRight: 16,
                    float: 'right'
                }}
            >
                新增
            </Button>
            <Modal title="新增项目" destroyOnClose={true} footer={null} open={isModalOpen} onCancel={handleCancel}>
                <MyForm columns={columns} onCancel={handleCancel} handleOk={handleOk} />
            </Modal>
            <Form form={form} component={false}>
                <Table
                    components={{
                        body: {
                            cell: EditableCell,
                        },
                    }}
                    bordered
                    expandable={data[0]?.wifi ? {
                        expandedRowRender: (record) => (
                            <p
                                style={{
                                    margin: 0,
                                    textAlign: "center"
                                }}
                            >
                                {`wifi: ${record.wifi}`}
                            </p>
                        ),
                    } : null}
                    dataSource={data}
                    columns={mergedColumns}
                    rowClassName="editable-row"
                    pagination={{
                        onChange: cancel,
                    }}
                />
            </Form>
        </>

    );
};

export default MyTable;